const pricingRoute = ({ user = {}, membership = {} } = {}) => {
    const status = membership?.status || 'pending';
    const role = user?.role || 'user';

    if (!status || status === "pending") {
        if (role === "training-provider") return [];

        if (["trainer", "gym"].includes(role)) {
            return [{ name: "Pricing", path: `/membership/${role}` }];
        }

        return [
            {
                name: "Pricing",
                subNavigation: [
                    { name: "Membership", path: "/membership/trainer" },
                    { name: "Gym", path: "/membership/gym" },
                ],
            },
        ];
    }

    return [];
};

const navigation_list = (props = {}) =>
    [
        { name: "Home", path: "/" },
        { name: "About", path: "/about" },
        {
            name: "Services",
            path: "/services/our-services",
            subNavigation: [
                { name: "Become a Member", path: "/services/our-services" },
                { name: "Get Your Facility Certified", path: "/services/elevate-standards" },
                { name: "Become a Training Provider", path: "/services/grow-with-fwpi" },
                { name: "Awards & Recognition", path: "/services/awards" },
            ],
        },
        {
            name: "FWPI Directory",
            subNavigation: [
                { name: "Members", path: "/trainer" },
                { name: "Gym Facility", path: "/gym" },
                // { name: "Training providers", path: "/training-provider" },
            ],
        },
        ...pricingRoute(props || {}),
        { name: "Contact Us", path: "/contact-us" },
    ].filter((nav) => nav?.path || (nav.subNavigation?.length > 0));

// Export a function you can call with { user, membership }
export const getNavigationList = navigation_list;

// Also export a default/static NAVIGATION_LIST (no user/membership)
export const NAVIGATION_LIST = navigation_list();
